import { render } from "./index.vue?vue&type=template&id=8c8fd914&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8c8fd914&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=8c8fd914&lang=scss"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8fd914"]])

export default __exports__